<template>
  <layout-default-appbar>
    Diversos
  </layout-default-appbar>
</template>

<script>

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewSincronizarAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
    };
  },
};
</script>
